module.exports = __webpack_public_path__ + "static/img/docSend_on.d0bd8072.svg";